// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"54":"2583dd9a","240":"887622a6","284":"9b0ae9c3","350":"01b6b22a"}[chunkId] + ".js";
};